var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBannerImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2,0 L19,0 C19.5522847,-1.01453063e-16 20,0.44771525 20,1 L20,20 C20,20.5522847 19.5522847,21 19,21 L2,21 C1.44771525,21 1,20.5522847 1,20 L1,1 C1,0.44771525 1.44771525,1.01453063e-16 2,0 Z M4,3 L4,18 L17,18 L17,3 L4,3 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 7,
  y: 12,
  width: 7,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 7,
  y: 14,
  width: 7,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 7,
  y: 16,
  width: 7,
  height: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,4 L16,4 L16,10 L5,10 L5,4 Z M8,6.2 L6,8 L15,8 L12.5,5 L10,7.4 L8,6.2 Z",
  fill: "currentColor"
}))));
export default SvgBannerImage;